import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import BottomSheet from './BottomSheet';
import { RadekUctenky } from './MojePokladnaPanel';
import { barvyPlochy } from './PlochaUI';

const DNI = 30;

/**
 * Historie mých účtenek za posledních 30 dní — nákupy i tankování na jednom
 * místě. Nahrazuje „Moje tankování" z bývalého sheetu auta: od chvíle, kdy se
 * tankování pozná z účtenky samo, patří jeho historie k účtenkám.
 */
export default function UctenkyHistorieSheet({ open, onClose, isDark, isMobile }) {
    const [uctenky, setUctenky] = useState(null);
    const [chyba, setChyba] = useState(false);
    const b = barvyPlochy(isDark);

    useEffect(() => {
        if (!open) return;
        let zivy = true;
        setUctenky(null); setChyba(false);
        fetch(`/api/me/moje-pokladna?dni=${DNI}`)
            .then(r => (r.ok ? r.json() : Promise.reject()))
            .then(d => { if (zivy) setUctenky(d.uctenky || []); })
            .catch(() => { if (zivy) setChyba(true); });
        return () => { zivy = false; };
    }, [open]);

    return (
        <BottomSheet open={open} onClose={onClose} isDark={isDark} isMobile={isMobile} title="Moje účtenky">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '0 16px 18px' }}>
                <span style={{ fontSize: 12.5, color: b.tlumena, paddingBottom: 4 }}>
                    Posledních {DNI} dní — nákupy i tankování.
                </span>
                {!uctenky && !chyba && (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: b.tlumena }}>
                        <Loader2 size={15} style={{ animation: 'spin 1s linear infinite' }} /> Načítám…
                    </span>
                )}
                {chyba && <span style={{ fontSize: 13, color: b.tlumena }}>Nepodařilo se načíst.</span>}
                {uctenky && !uctenky.length && (
                    <span style={{ fontSize: 13, color: b.tlumena }}>Za posledních {DNI} dní žádná účtenka.</span>
                )}
                {uctenky?.map(u => <RadekUctenky key={u.id} u={u} isDark={isDark} sDatem />)}
            </div>
        </BottomSheet>
    );
}
